import { createAction } from '@reduxjs/toolkit'

import type {
  EarlierLoadedPayload,
  FetchEarlierPayload,
  FreshLoadedPayload,
  MarkReadPayload,
  OpenPayload,
  ProjectPayload,
  ProjectSettingsLoadedPayload,
  SaveProjectSettingsPayload,
  WorkspacePayload,
  WorkspaceUnread,
} from './types'

export const InboxActions = {
  fetchUnread: createAction('INBOX_FETCH_UNREAD'),
  fetchFresh: createAction<WorkspacePayload>('INBOX_FETCH_FRESH'),
  fetchEarlier: createAction<FetchEarlierPayload>('INBOX_FETCH_EARLIER'),
  markRead: createAction<MarkReadPayload>('INBOX_MARK_READ'),
  markAllRead: createAction<WorkspacePayload>('INBOX_MARK_ALL_READ'),
  // a click on a row: read, then off to the discussion or the project
  open: createAction<OpenPayload>('INBOX_OPEN'),
  fetchProjectSettings: createAction<ProjectPayload>(
    'INBOX_FETCH_PROJECT_SETTINGS'
  ),
  saveProjectSettings: createAction<SaveProjectSettingsPayload>(
    'INBOX_SAVE_PROJECT_SETTINGS'
  ),
}

export const InternalInboxActions = {
  setUnread: createAction<WorkspaceUnread[]>('INBOX_INTERNAL_SET_UNREAD'),
  freshLoaded: createAction<FreshLoadedPayload>('INBOX_INTERNAL_FRESH_LOADED'),
  earlierLoading: createAction<WorkspacePayload>(
    'INBOX_INTERNAL_EARLIER_LOADING'
  ),
  earlierLoaded: createAction<EarlierLoadedPayload>(
    'INBOX_INTERNAL_EARLIER_LOADED'
  ),
  earlierFailed: createAction<WorkspacePayload>(
    'INBOX_INTERNAL_EARLIER_FAILED'
  ),
  readLocally: createAction<MarkReadPayload>('INBOX_INTERNAL_READ_LOCALLY'),
  allReadLocally: createAction<WorkspacePayload>(
    'INBOX_INTERNAL_ALL_READ_LOCALLY'
  ),
  projectSettingsLoaded: createAction<ProjectSettingsLoadedPayload>(
    'INBOX_INTERNAL_PROJECT_SETTINGS_LOADED'
  ),
}
